import(/* webpackMode: "eager", webpackExports: ["GamePage"] */ "/app/apps/royalur/src/app/game/GamePage.tsx");
